import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes } from '@angular/router';
import { JhiPaginationUtil, JhiResolvePagingParams } from 'ng-jhipster';
import { UserRouteAccessService } from 'src/app/core';
import { Observable } from 'rxjs';
import { FileDataMySuffix } from 'src/app/shared/model/file-data-my-suffix.model';
import { FileDataMySuffixService } from './file-data-my-suffix.service';
import { FileDataMySuffixComponent } from './file-data-my-suffix.component';
import { FileDataMySuffixDetailComponent } from './file-data-my-suffix-detail.component';
import { FileDataMySuffixUpdateComponent } from './file-data-my-suffix-update.component';
import { FileDataMySuffixDeletePopupComponent } from './file-data-my-suffix-delete-dialog.component';
import { IFileDataMySuffix } from 'src/app/shared/model/file-data-my-suffix.model';

@Injectable({ providedIn: 'root' })
export class FileDataMySuffixResolve implements Resolve<IFileDataMySuffix> {
    constructor(private service: FileDataMySuffixService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const id = route.params['id'] ? route.params['id'] : null;
        if (id) {
            return this.service.find(id).map((fileData: HttpResponse<FileDataMySuffix>) => fileData.body);
        }
        return Observable.of(new FileDataMySuffix());
    }
}

export const fileDataRoute: Routes = [
    {
        path: 'file-data-my-suffix',
        component: FileDataMySuffixComponent,
        resolve: {
            pagingParams: JhiResolvePagingParams
        },
        data: {
            authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ADMIN_STAFF', 'BROKER', 'BROKER_STAFF'],
            defaultSort: 'id,asc',
            pageTitle: 'FileData'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'file-data-my-suffix/:id/view',
        component: FileDataMySuffixDetailComponent,
        resolve: {
            fileData: FileDataMySuffixResolve
        },
        data: {
            authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ADMIN_STAFF', 'BROKER', 'BROKER_STAFF'],
            pageTitle: 'FileData'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'file-data-my-suffix/new',
        component: FileDataMySuffixUpdateComponent,
        resolve: {
            fileData: FileDataMySuffixResolve
        },
        data: {
            authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ADMIN_STAFF', 'BROKER', 'BROKER_STAFF'],
            pageTitle: 'FileData'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'file-data-my-suffix/:id/edit',
        component: FileDataMySuffixUpdateComponent,
        resolve: {
            fileData: FileDataMySuffixResolve
        },
        data: {
            authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ADMIN_STAFF', 'BROKER', 'BROKER_STAFF'],
            pageTitle: 'FileData'
        },
        canActivate: [UserRouteAccessService]
    }
];

export const fileDataPopupRoute: Routes = [
    {
        path: 'file-data-my-suffix/:id/delete',
        component: FileDataMySuffixDeletePopupComponent,
        resolve: {
            fileData: FileDataMySuffixResolve
        },
        data: {
            authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ADMIN_STAFF', 'BROKER', 'BROKER_STAFF'],
            pageTitle: 'FileData'
        },
        canActivate: [UserRouteAccessService],
        outlet: 'popup'
    }
];
